export interface MainNavigationItem {
  name: string;
  routerLink: string;
}

export const patientsNavItems: MainNavigationItem[] = [
  {
    name: 'NAV_ITEMS.HOME',
    routerLink: '/patients'
  },
  {
    name: 'NAV_ITEMS.ABOUT_US',
    routerLink: '/patients/about-us'
  },
  {
    name: 'NAV_ITEMS.CONTACT',
    routerLink: '/patients/contact'
  },
  {
    name: 'NAV_ITEMS.NEWS',
    routerLink: '/patients/news'
  }
];

export const healthWorkersNavItems: MainNavigationItem[] = [
  {
    name: 'NAV_ITEMS.HOME',
    routerLink: '/health_workers'
  },
  {
    name: 'NAV_ITEMS.ABOUT_US',
    routerLink: '/health_workers/about-us'
  },
  {
    name: 'NAV_ITEMS.CONTACT',
    routerLink: '/health_workers/contact'
  },
  {
    name: 'NAV_ITEMS.NEWS',
    routerLink: '/health_workers/news'
  }
];
